import { graphql } from '../gql';

export const getCompletedCateringEventDetails = graphql(`
  query GetCompletedCateringEventDetails($input: GetEventVendorsInput!) {
    getEventVendors(input: $input) {
      error {
        code
        message
      }
      eventVendors {
        __typename
        id
        productType
        ... on CateringEventVendor {
          packingSlipConfirmed
          purchaseOrderConfirmed
          packingSlipUrl
          purchaseOrderUrl
          totalMenuLineItems
          vendor {
            id
            internalName
            address {
              id
              address1
              address2
              city
              state
              zipCode
              country
            }
          }
          event {
            id
            name
            startTime
            endTime
            status
            setupTime
            account {
              id
              name
            }
            location {
              id
              name
              building {
                id
                name
                address {
                  id
                  address1
                  address2
                  city
                  state
                  zipCode
                  country
                }
              }
            }
          }
          menuLineItems(limit: 10) {
            id
            name
            quantity
            unitPriceCents
            totalPriceCents
          }
        }
      }
    }
  }
`);
